import { PAGE_RENDER_TYPE } from "../constants/enumerates";

export const createMenuSlice = (set) => ({
  menuList: [],
  setMenuList: (menuList) => {
    set((state) => {
      state.menu.menuList = menuList;
    });
  },
  hierarchyMenu: [],
  setHierarchyMenu: (hierarchyMenu) => {
    set((state) => {
      state.menu.hierarchyMenu = hierarchyMenu;
    });
  },
  pageRenderType: PAGE_RENDER_TYPE.TAB, // PAGE_RENDER_TYPE.PAGE,
  setPageRenderType: (pageRenderType) => {
    set((state) => {
      state.menu.pageRenderType = pageRenderType;
    });
  },
  showTopMenuYn: "Y",
  setShowTopMenuYn: (yn) => {
    set((state) => {
      state.menu.showTopMenuYn = yn;
    });
  },
  favoriteMenu: [],
  setFavoriteMenu: (favoriteMenu) => {
    set((state) => {
      state.menu.favoriteMenu = favoriteMenu;
    });
  },
  selectedMenu: {
    menuId: "",
    menuName: "",
    helpYn: "",
    sideYn: "N",
    displayYn: "N",
    menuNameList: "",
    menuNameListId: "",
  },
  setSelectedMenu: (selectedMenu) => {
    set((state) => {
      state.menu.selectedMenu = selectedMenu;
    });
  },
  selectedTopMenu: {
    menuId: "",
    menuName: "",
    helpYn: "",
    sideYn: "N",
    displayYn: "N",
    menuNameList: "",
    menuNameListId: "",
  },
  setSelectedTopMenu: (selectedTopMenu) => {
    set((state) => {
      state.menu.selectedTopMenu = selectedTopMenu;
    });
  },
  helpMenuYn: "N",
  setHelpMenuYn: (helpMenuYn) => {
    set((state) => {
      state.menu.helpMenuYn = helpMenuYn;
    });
  },
  resetMenu: () => {
    set((state) => {
      state.menu.menuList = [];
      state.menu.hierarchyMenu = [];
      state.menu.favoriteMenu = [];
      state.menu.selectedMenu = {};
      state.menu.selectedTopMenu = {};
      state.menu.helpMenu = {};
    });
  },
});
